import { createContext, useContext } from 'react';

export interface MTabsContextValue {
  isLazy?: boolean;
}

export const MTabsContext = createContext<MTabsContextValue>({});

export const useMTabsContext = () => useContext(MTabsContext);
